import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { DocumentService } from '../../core/services/document.service';

@Component({
  selector: 'app-post-landing-layout',
  imports: [RouterModule, InlineSVGModule],
  templateUrl: './post-landing-layout.component.html',
  styleUrl: './post-landing-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PostLandingLayoutComponent {
  constructor(documentService: DocumentService) {
    documentService.injectAdsenseScript();
  }
}
